import { BaseService } from "../base.service";

export class IntegrationService extends BaseService {
  constructor() {
    super();
  }

  async addIntegration(integration) {
    const resp = await this.client.post(
      "/company/integration",
      {
        ...integration,
      }
    );

    return resp?.data;
  }

  async getIntegrations() {
    const resp = await this.client.get("/company/integration/list");

    return resp?.data;
  }

  async updateIntegration(integrationId, data) {
    const resp = await this.client.put(
      `/company/integration`,
      {
        id: integrationId,
        ...data,
      }
    );
  }

  async deleteIntegration(integrationId) {
    const resp = await this.client.post(
      `/company/integration/delete`,
      {
        id: integrationId,
      }
    );

    return resp?.data;
  }
}

export const integrationService = new IntegrationService();
